import React, { useEffect, useState, useRef } from 'react';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { useBranchContext } from '../../components/Context/BranchContext';
import { useSnackbar } from '.././SnackBar';
import { useProgressBar } from '.././ProgressBar';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import { Tabs, Tab, Box, Typography, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TextField, InputAdornment, IconButton, Dialog, DialogTitle, DialogContentText, DialogActions, DialogContent } from '@mui/material';
// import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';

//import { Formik, Form, Field, ErrorMessage } from 'formik';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}


const NewService = ({ Partnersdata }) => {
  const [isDiscountEnabled, setIsDiscountEnabled] = useState(false);
  const [discount, setDiscount] = useState('');
  const { showSnackbar } = useSnackbar();
  const { showProgress } = useProgressBar()
  const { service, additionalService, FetchServiceCategory, FetchAdditionalService, serviceCategory, AddService } = useServiceContext();
  const { branches, FetchBranches } = useBranchContext();
  const nameRef = useRef('');
  const categoryRef = useRef('');
  const priceRef = useRef('');
  const descriptionRef = useRef('');
  const discountRef = useRef();
  const navigate = useNavigate()
  const branchRef = useRef('');
  const addServiceRef = useRef('');
  const [selectedFile, setSelectedFile] = useState(null);
  const isPeriodicRef = useRef(false);
  const isQuickSelectRef = useRef(false);
  // const [items, setItems] = useState([]);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]); // Get the first selected file
  };
  const formRef = useRef(null);
  const handleClick = () => {
    const formElements = formRef.current.elements;
    for (let element of formElements) {
      if ((element.tagName === 'INPUT' && element.type != 'BUTTON')) {
        if (element.value === "") {
          element.style.borderColor = 'red';
        } else {
          element.style.borderColor = '';

        }
      }
    }

  };
  const emptyFields = (e) => {
    if (e.target.value === "") {
      e.target.style.borderColor = ''
    } else {
      e.target.style.borderColor = '';
    }
  }
  const handleAddService = async () => {
    const Name = nameRef.current.value;
    //const serviceCatergoryId = categoryRef.current.value;
    const price = priceRef.current.value;
    const description = descriptionRef.current.value;
    // const branchId = branchRef.current.value;
    // const additionalServiceId = addServiceRef.current.value;

    if (Name === '' || price === '' || serviceCatergoryId === '') {
      showSnackbar('Service name/Price/ServiceCategory cannot be empty.');
      handleClick();
      return;
    }

    showProgress(true);

    try {
      const servicedata = {
        name: Name,
        ServiceCategoryId: serviceCatergoryId,
        price: price,
        description: description,
        imageUrl: "",
        branchId: selectedbranches,
        additionalServiceId: selectedAddSer,
        finalPrice: 0,
        discounted: isDiscountEnabled,
        homeServiceEnabled: homeServiceEnabled,
        serviceCharge: homeServiceEnabled ? serviceChargeRef.current.value : 0,
        discountPercentage: isDiscountEnabled ? discountRef.current.value : 0,
        isPeriodic: isPeriodicRef.current?.checked || false,
        isQuickSelect: isQuickSelectRef.current?.checked || false,
      };
      debugger
      await AddService(servicedata, selectedFile);
      showProgress(false);
      showSnackbar('Service  added successfully!');
      navigate('/partnerservice');
    } catch (error) {
      showSnackbar('Error adding Service . Please try again.');
      console.error('Error adding Service :', error);
    }
  };

  const [additionalName, setAdditionalName] = React.useState([]);
  const [branchName, setBranchName] = React.useState([]);
  const theme = useTheme();
  const [selectedbranches, setBranches] = React.useState([]);
  const [selectedAddSer, setAddServ] = useState([]);

  const handleAddServChange = (event) => {
    const {
      target: { value },
    } = event;
    setAdditionalName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
    const strvalue = value.map(num => num.toString());
    setAddServ(strvalue); // Store selected IDs
  };



  const handleBranchChange = (event) => {
    const {
      target: { value },
    } = event;
    setBranchName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
    const strvalue = value.map(num => num.toString());



    setBranches(strvalue);
  };
  const [serviceCatergoryId, setCategoryId] = useState([]);
  const handleCategorychange = (event) => {
    const value = `${event.target.value}`;
    setCategoryId(value);
  };

  // const handleAddServchange = (event) => {
  //     const {
  //         target: { value },
  //       } = event;
  //       setAddServ(
  //         // On autofill we get a stringified value.
  //         typeof value === 'string' ? value.split(',') : value,
  //       );
  // };

  //const handleDelete = (a) => () => {

  //    
  //    selectedAddSer((a) => a.filter((person) => a !== a));
  //};
  const handleDelete = (event, value) => {

    alert(1)
  };
  const didFetch = useRef(false);
  const getData = async () => {
    try {
      await FetchServiceCategory();
      await FetchAdditionalService();
      await FetchBranches();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {

    if (!didFetch.current) {
      getData();
      didFetch.current = true; // Mark the API call as done
    }
  });
  const handleToggleDiscount = () => {
    setIsDiscountEnabled(!isDiscountEnabled);
  };

  const handleDiscountChange = (event) => {
    setDiscount(event.target.value);
  };

  const [homeServiceEnabled, setHomeServiceEnabled] = useState(false);
  const [serviceCharge, setServiceCharge] = useState('');
  const serviceChargeRef = useRef(null);

  const handleToggleHomeService = () => {
    setHomeServiceEnabled((prev) => !prev);
  };

  const handleServiceChargeChange = (e) => {
    const value = e.target.value;
    setServiceCharge(value);
  };

  const [confirmIsPeriodicRefStatusOpen, setConfirmIsPeriodicRefStatusOpen] = useState(false);
  const [previousIsPeriodicValue, setPreviousIsPeriodicValue] = useState(false);
  const handleIsPeriodicActive = () => {
    if (isPeriodicRef.current) {
      const current = isPeriodicRef.current.checked;
      // Save previous value before showing dialog
      setPreviousIsPeriodicValue(!current); // Store old state
      setConfirmIsPeriodicRefStatusOpen(true); // Open dialog
    }
  };
  const handleIsPeriodicConfirmStatusChange = () => {
    const isChecked = isPeriodicRef.current?.checked || false;
    // Perform your update logic here (API call, state update, etc.)
    console.log('Status changed to:', isChecked ? 'Enabled' : 'Disabled');

    setConfirmIsPeriodicRefStatusOpen(false);
  };
  const handleIsPeriodicStatusDialogClose = () => {
    if (isPeriodicRef.current) {
      isPeriodicRef.current.checked = previousIsPeriodicValue;
    }
    setConfirmIsPeriodicRefStatusOpen(false); // Close the dialog
  };

  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Service</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/partnerservice">Home</a></li>
              <li className="breadcrumb-item"><a href="/partnerservice">Services</a></li>
              <li className="breadcrumb-item active"><a href="#">New Service</a></li>
            </ol>
          </nav>
        </div>
        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">New Service Details</h5>
                  <div>
                    <form ref={formRef}>
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-2 col-form-label">Name</label>
                        <div className="col-sm-6">
                          <input type="text" className="form-control" ref={nameRef} onBlur={(e) => { emptyFields(e); }}></input>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Service Category</label>
                        <div className="col-sm-6">
                          <FormControl fullWidth sx={{ width: '300px' }}>
                            <Select id="fruits" name="fruits" className="form-control" onChange={handleCategorychange}
                              sx={{
                                width: "300px",           // Adjust width as needed
                                // Rounded corners
                                "& .MuiOutlinedInput-root": {

                                },
                                "& .MuiSelect-select": {
                                  padding: "8px 12px",     // Adjust padding
                                },
                              }}>
                              {serviceCategory.map((category) => (
                                <MenuItem key={category.id} value={category.serviceCategoryId}>
                                  {category.serviceCategoryName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="phone" className="col-sm-2 col-form-label">Price:</label>
                        <div className="col-sm-6">
                          <input type="tel" id="phone" name="phone" className="form-control" required ref={priceRef} onBlur={(e) => { emptyFields(e); }}></input>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputEmail" className="col-sm-2 col-form-label">Description</label>
                        <div className="col-sm-6">
                          <input type="email" className="form-control" ref={descriptionRef} onBlur={(e) => { emptyFields(e); }}></input>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Image</label>
                        <div className="col-sm-6">
                          <input className="form-control" type="file" id="formFile" onChange={handleFileChange} onBlur={(e) => { emptyFields(e); }} />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Branch</label>
                        <div className="col-sm-6">
                          <FormControl fullWidth sx={{ width: '300px' }}>
                            {/*                    <Select*/}
                            {/*                        labelId="multi-select-label"*/}

                            {/*multiple*/}
                            {/*value={selectedbranches} ref={branchRef}*/}
                            {/*onChange={handleBranchChange}*/}

                            {/*renderValue={(selected) => {*/}

                            {/*  // Find names corresponding to selected IDs*/}
                            {/*  const branchselected = branches*/}
                            {/*      .filter(item => selected.includes(item.id))*/}
                            {/*      .map(item => item.name);*/}
                            {/*    return branchselected.join(', ');*/}

                            {/*    }}*/}
                            {/*                        sx={{*/}
                            {/*                            width: "300px",           // Adjust width as needed*/}
                            {/*                            // Rounded corners*/}
                            {/*                            "& .MuiOutlinedInput-root": {*/}

                            {/*                            },*/}
                            {/*                            "& .MuiSelect-select": {*/}
                            {/*                                padding: "8px 12px",     // Adjust padding*/}
                            {/*                            },*/}
                            {/*                        }}*/}
                            {/*>*/}
                            {/*{branches.map((branch) => (*/}
                            {/*    <MenuItem key={branch.id} value={branch.id}>*/}
                            {/*    <Checkbox checked={selectedbranches.indexOf(branch.id) > -1} />*/}
                            {/*    <ListItemText primary={branch.name} />*/}
                            {/*    </MenuItem>*/}
                            {/*))}*/}
                            {/*                    </Select>*/}
                            <Select
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              value={branchName}
                              onChange={handleBranchChange}


                              renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                  {selected.map((value) => {
                                    // Find the name corresponding to the selected ID

                                    const selectedItem = branches.find(item => item.id === value);
                                    return (
                                      <Chip
                                        key={value}
                                        label={selectedItem?.name}

                                      />
                                    );
                                  })}
                                </Box>
                              )}

                              sx={{
                                width: "300px",           // Adjust width as needed
                                // Rounded corners
                                "& .MuiOutlinedInput-root": {

                                },
                                "& .MuiSelect-select": {
                                  padding: "8px 12px",     // Adjust padding
                                },
                              }}
                            >
                              {branches.map((value) => (
                                <MenuItem key={value.name} value={value.id}>
                                  <Checkbox checked={branchName.includes(value.id)} />
                                  <ListItemText primary={value.name} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>

                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Additional Services</label>
                        <div className="col-sm-6">


                          <FormControl fullWidth sx={{ width: '300px' }}>
                            <Select
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              value={additionalName}
                              onChange={handleAddServChange}


                              renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                  {selected.map((value) => {
                                    // Find the name corresponding to the selected ID

                                    const selectedItem = additionalService.find(item => item.id === value);
                                    return (
                                      <Chip
                                        key={value}
                                        label={selectedItem?.name}

                                      />
                                    );
                                  })}
                                </Box>
                              )}

                              sx={{
                                width: "300px",           // Adjust width as needed
                                // Rounded corners
                                "& .MuiOutlinedInput-root": {

                                },
                                "& .MuiSelect-select": {
                                  padding: "8px 12px",     // Adjust padding
                                },
                              }}
                            >
                              {additionalService.map((value) => (
                                <MenuItem key={value.name} value={value.id}>
                                  <Checkbox checked={additionalName.includes(value.id)} />
                                  <ListItemText primary={value.name} />
                                </MenuItem>
                              ))}
                            </Select>

                          </FormControl>  </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-4">
                          Mark as periodic service
                        </div>
                        <div className="col-md-8"  >
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexSwitchCheckDefault"
                              ref={isPeriodicRef}
                              onChange={handleIsPeriodicActive}
                            />
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">

                              {isPeriodicRef.current?.checked ? 'Active' : 'Not Active'}
                            </label>
                          </div>
                        </div>


                        <Dialog open={confirmIsPeriodicRefStatusOpen} onClose={handleIsPeriodicStatusDialogClose}>
                          <DialogTitle>Confirm Status Change</DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              Are you sure you want to {isPeriodicRef.current?.checked ? 'activate' : 'deactivate'} for this service?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleIsPeriodicStatusDialogClose} color="secondary">
                              Cancel
                            </Button>
                            <Button onClick={handleIsPeriodicConfirmStatusChange} color="primary" autoFocus>
                              Confirm
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-4">
                          Quick select in partner app
                        </div>
                        <div className="col-md-8">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="quickSelectSwitch"
                              ref={isQuickSelectRef}
                            />
                            <label className="form-check-label" htmlFor="quickSelectSwitch">
                              Show as one-tap service on order screen
                            </label>
                          </div>
                        </div>
                      </div>


                      <div className="text-end">
                        <Button className="right-button"
                          variant="contained"
                          color="primary"
                          style={{
                            backgroundColor: '#02176D', color: 'white'
                          }}
                          onClick={handleAddService}
                        // disabled={brands.length === 0}
                        >
                          Save
                        </Button>
                      </div>
                      <div className="form-check form-switch mb-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="toggleDiscount"
                          onChange={handleToggleDiscount}
                          checked={isDiscountEnabled}
                        />
                        <label className="form-check-label" htmlFor="toggleDiscount">
                          Enable Discount
                        </label>
                      </div> {isDiscountEnabled && (
                        <div className="row mb-3">
                          <label htmlFor="discount" className="col-sm-2 col-form-label">Discount (%):</label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              ref={discountRef}
                              className="form-control"
                              id="discount"
                              value={discount}
                              onChange={handleDiscountChange}
                              min="0"
                              max="100"
                              placeholder="Enter discount percentage"
                              required
                              onBlur={(e) => { emptyFields(e); }}
                            />
                          </div>
                        </div>
                      )}<div className="form-check form-switch mb-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="toggleHomeService"
                          onChange={handleToggleHomeService}
                          checked={homeServiceEnabled}
                        />
                        <label className="form-check-label" htmlFor="toggleHomeService">
                          Enable Home Service
                        </label>
                      </div>
                      {homeServiceEnabled && (
                        <div className="row mb-3">
                          <label htmlFor="serviceCharge" className="col-sm-2 col-form-label">Service Charge:</label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              ref={serviceChargeRef}
                              className="form-control"
                              id="serviceCharge"
                              value={serviceCharge}
                              onChange={handleServiceChargeChange}
                              min="0"
                              placeholder="Enter service charge"
                              required
                              onBlur={(e) => { emptyFields(e); }}
                            />
                          </div>
                        </div>
                      )}

                    </form>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>
      </main>

      <footer id="footer" className="footer">
        <div className="copyright">
          &copy; Copyright <strong><span>CarCare+</span></strong>. All Rights Reserved
        </div>
      </footer>
    </div>
  )
};

export default NewService;